import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { listSignupForm, readSignupForm } from 'actions/signupForm'
import { receiveForm, selectFormType } from 'actions/signupForm/addOrEdit'
import { getAllGroups } from 'actions/contacts/groups'
import { listPreferences } from 'actions/AccountSettings'
import Form from './Form/'
import Prompt from './Prompt'
import Paper from '@material-ui/core/Paper'
import { withStyles } from '@material-ui/core'
import { receiveForm as receiveCustomForm } from 'actions/customForm/addOrEdit'
import { read } from 'actions/data'
import { stepperGoTo } from 'actions/view'
import { ingestPrediction, consumePrediction } from 'actions/predictions'

const styles = theme => ({
  // ...other styles for the pages
  content: {
    padding: '84px 24px 24px',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      padding: '54px 0 0',
    },
  },
  paper: {
    border: '1px solid #adadad',
    padding: 20,
    borderRadius: 35,
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
      border: 'none',
      overflowY: 'auto',
    },
  },
})

export default connect(
	(state, { match }) => ({
		form:
			// state.signupForm.forms[match.params.formID] ||
			state.data?.customform?.[match.params.formID] ||
			null,
		formID: match.params.formID,
		formType: match.params.formType,
		formsLoadStatus: state.loadStatus.forms,
		createSignupForm: state.predictions?.createSignupForm,
		lastIntent: state.predictions?.lastIntent,
		lastQuery: state.predictions?.lastQuery,
		paperTransparent:
			state.signupForm.addOrEdit.formTypeSelected === 'custom' &&
			(state.view.stepper.form === 1 || state.view.stepper.form === 3),
	}),
	(dispatch) =>
		bindActionCreators(
			{
				listSignupForm,
				readSignupForm,
				receiveForm,
				getAllGroups,
				listPreferences,
				receiveCustomForm,
				read,
				stepperGoTo,
				selectFormType,
				ingestPrediction,
				consumePrediction,
			},
			dispatch,
		),
)(
	withStyles(styles)(
		class AddOrEditFormPage extends Component {
			componentDidMount() {
				if (this.props.formType === 'signup') {
					if (this.props.formID && this.props.formID !== 'new') {
						if (this.props.form) {
							this.props
								.receiveForm(this.props.form)
								.then(() =>
									this.props
										.readSignupForm(this.props.formID)
										.then((payload) => this.props.receiveForm(payload)),
								)
						} else {
							this.props
								.readSignupForm(this.props.formID)
								.then((payload) => this.props.receiveForm(payload))
						}
					} else if (this.props.formID === 'new') {
						this.props.selectFormType('signup')
						this.props.stepperGoTo(1, 'form')
					}
				} else if (
					this.props.formType === 'custom' ||
					this.props.formType === 'customIntegration'
				) {
					if (this.props.formID && this.props.formID !== 'new') {
						if (this.props.form) {
							this.props
								.receiveCustomForm(this.props.form)
								.then(() =>
									this.props
										.read(this.props.formID, 'customform')
										.then((payload) => this.props.receiveCustomForm(payload)),
								)
						} else {
							this.props
								.read(this.props.formID, 'customform')
								.then((payload) => this.props.receiveCustomForm(payload))
						}
					} else if (this.props.formID === 'new') {
						this.props.selectFormType('custom')
						this.props.stepperGoTo(1, 'form')
					}
				}

				if (!this.props.formsLoadStatus) {
					this.props.listPreferences()
					this.props.listSignupForm()
				}

				this.props.getAllGroups()

				this.handlePrediction()
			}

			componentDidUpdate(prevProps) {
				if (
					this.props.lastIntent === 'createSignupForm' &&
					prevProps.lastQuery === '' &&
					prevProps.lastQuery !== this.props.lastQuery
				) {
					console.log('queries arent equal')
					this.handlePrediction()
				}
			}

			componentWillUnmount() {
				this.props.receiveForm(null)
				this.props.receiveCustomForm(null)
			}

			handlePrediction = () => {
				const { ingestPrediction, createSignupForm, consumePrediction } =
					this.props
				if (createSignupForm && createSignupForm.entities.length) {
					Promise.resolve(
						ingestPrediction(createSignupForm.entities, 'createSignupForm'),
					).then(() => consumePrediction('createSignupForm'))
				}
			}

			render() {
				return (
					<div className={this.props.classes.content}>
						<Paper
							style={
								this.props.paperTransparent
									? {
											backgroundColor: 'transparent',
											border: 'none',
											boxShadow: 'none',
									  }
									: null
							}
							className={this.props.classes.paper}
						>
							<div style={{ height: '100%' }}>
								{this.props.form || this.props.formID === 'new' ? (
									<Form style={{ height: '100%' }} />
								) : (
									'Loading...'
								)}
								<Prompt />
							</div>
						</Paper>
					</div>
				)
			}
		},
	),
)
